<template>
  <div>
    <!-- 税费直达快享--精准推送 -->
    <div class="wrap-content">
      <div class="content-body">
        <div class="pad-tb-1 pad-rl-2 content-header">
          <span class="result">
          <el-button class="computeBtn" round @click="groupTimeGX()"
          >按更新时间排序</el-button
          >
          <el-button class="computeBtn" round @click="groupTimeFB()"
          >按发布时间排序</el-button
          >

        </span>
          <div class="searchbar">
            <FormInput v-model="searchInfo.data.keywords"></FormInput>
            <el-button size="medium" type="primary" @click="changeKeywords"
            >搜索</el-button
            >
          </div>
        </div>
        <div class="content-body">
          <div>
        <div
          class="pad-1 bord-r-1 marg-tb-1 marg-rl-2 policy-item"
          v-for="(item, index) in listData"
          :key="index"
        >
          <div class="pad-rl-1 bord-r-1 policy-zcfs">
              <span
                v-for="(proj, index) in cpu_policyProjectList(item)"
                :key="index"
                v-show="proj.zcname"
                class="zcfs-item"
              >{{ proj.zcname }}</span
              >
          </div>
          <h3 class="policy-name" @click="toPolicyDetail(item,item.typeFlag)">{{ item.name }}</h3>
          <div>
            <div v-if="item.typeFlag == '1'">
              <div >
                <div class="policy-content" style="padding-right:3%"  v-html="cutout(item.content1)" ></div>
              </div>
            </div>
            <div else>
              <div v-for="(entry,index) in (item.entrys)" :key="index">
                <div class="policy-content" style="padding-right:3%"  v-html="cutout(entry.entryName)" ></div>
              </div>
            </div>

          <!-- <div v-for="(entry,index) in dealEntryNumber(item)" :key="index" v-html="cutout(entry.entryName)">
          </div> -->
          </div>
          <!-- 底部内容 -->
          <div class="policy-infos" v-if="item.typeFlag != '1'">
            <div
              v-for="(info, index) in policyInfos"
              :key="index"
              class="info-item"
              :style="{ width: info.width }"
            >
              <label class="info-label">{{ info.label }}：</label>
              <div class="info-value">
                <template v-if="info.valueFormatter">{{
                    info.valueFormatter(item)
                  }}
                </template>
                <template v-else>{{ item[info.valueKey] }}</template>
              </div>
            </div>
          </div>
        </div>
          </div>
        <el-pagination
          class="marg-tb-2"
          style="text-align: center"
          background
          layout="prev,pager,next,total,jumper"
          :current-page.sync="pageInfo.page"
          :page-size.sync="pageInfo.size"
          :total="pageInfo.total"
          @current-change="changePage"
        ></el-pagination>
      </div>
        </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import { FormInput } from "@/components/form/index.js";
import {FilterGroup, FilterItem} from "@/views/findList/components/filter";
import TjCommonDialog from "@/components/tj-common-dialog/TjCommonDialog";
import $tjCommonDialog from "@/components/tj-common-dialog";

export default {
  name: "VipPush",
  components: {
    FormInput,
  },
  props: {},
  data() {
    return {
      listData: [],
      policyInfos: [
        {
          width: "200px",
          label: "政策等级",
          valueFormatter: (item) => {
            if (!item.areaid) return "--";
            return this.getDictLabel("areaLevel", item.areaid);
          },
        },
        {
          width: "400px",
          label: "发文单位",
          valueKey: "fbjg",
        },
        {
          label: "发布日期",
          valueKey: "publictime",
        },
      ],
      pageInfo: {
        page: 1,
        size: 10,
        total: 0,
      },
      searchInfo: {
        data: {
          keywords: "", // 关键字
          releaseTime: 1, // 印发时间排序
          canCalculate: false, // 是否可计算
        },
      },
      sortByType: 1, //  0 是更新时间排序    1是发布时间排序
    };
  },
  created() {
  },
  mounted() {
    setTimeout(() => {
      // 该页面需要登录，若未登录，提示并重定向到 单点登录页面
      if (!this.token && !this.userInfo) {
        let cf = window.confirm("登录后即可访问'税务政策订阅'，即将前往登录");
        if (cf) {
          // let url = `${LOGIN_URL}?refer=cp&backUrl=${LOGIN_URL_BACK}`;
          // url += `?targetUrl=${window.location.host}`;
          // window.location.href = url;
          this.$router.push({ path: "/login2" });
          //window.location.href = "http://222.141.201.20:8060/#/login2"
        } else {
          this.$router.go(-1);
        }
        return;
      }
      this.queryListData();
    }, 200);
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      getDictList: "dictionary/getDictList",
      getDictLabel: "dictionary/getDictLabel",
    }),
    /**
     * @description: 税类型下的标签列表
     * @return {Array}
     */
    cpu_tagList() {
      // 标签的parentId为父类的id
      let arr = this.searchInfo.typeTagData.filter((cv) => cv.parentId !== "0");
      if (!this.searchInfo.data.type) return arr;
      return arr.filter((cv) => cv.parentId == this.searchInfo.data.type);
    },
    cpu_policyProjectList() {
      return function (policy) {
        return policy.cfgPermitItemInfoList || [];
      };
    },
  },
  methods: {
     cutout(cellValue) {
      // cellValue = cellValue.replace(/(^\s*)|(\s*$)/g, "");
      cellValue = cellValue.replace(/\s+/g, "");
      if(cellValue.length>80){
        cellValue = cellValue.substr(0, 100)+"..."
      }
      return cellValue
    },
    dealEntryNumber(){
      return function (item) {
        if(item.length>3){
          return item.slice(0,3);
        }else {
          return item || [];
        }
      };
    },
    //按照发布时间
    groupTimeFB() {
      this.sortByType = 1;
      this.queryListData();
    },
    //按照更新时间
    groupTimeGX() {
      this.sortByType = 0;
      this.queryListData();
    },

    /**
     * @description: 修改搜索条件 关键字
     */
    changeKeywords() {
      this.listData = [];
      this.pageInfo.total = 0;
      this.pageInfo.page = 1;
      this.queryListData();
    },
    toPolicyDetail(policy, flagType) {
      let that = this;
      if(flagType == '1'){  // 指引
        let { href } = that.$router.resolve({
          path: "/notice/detail/" + policy.id + "?detailType=3",
          query:{
            showSideNav:true,
          }
        });
        window.open(href, "_blank");
        return false;
      }

      window.sessionStorage.setItem("policyDetailData", JSON.stringify(policy));
      window.sessionStorage.setItem("flag", true);
      window.sessionStorage.setItem("status", true);
      // this.$router.push({
      //   name: "showPolicyDetail",
      //   query:{
      //     showSideNav:true,
      //   }
      // });
      // let { href } = this.$router.resolve({
      //     name: "showPolicyDetail",
      //     query:{
      //         showSideNav:true,
      //     }
      // });
      // window.open(href,"_blank");
      this.$router.push({
        name: "showPolicyDetail",
        query:{
          showSideNav:true,
        }
      })
    },

    changeTab(e) {
      // console.log('goQuickEntry:', e)
      if (e.target.nodeName.toLowerCase() === "li") {
        this.tabInfo.active = e.target.getAttribute("data-cpn");
      }
    },
    changePage() {
    },
    toAdvisory() {
      $tjCommonDialog.init({
        width: "400px",
        showClose: true,
        contentComponent: () => import("../sf-policy-library/ExpertAdvisory"),
      });
    },

    queryListData() {
      let url = `/dev-api/sqzd/policyPush/getPushPolicy?pageNum=${this.pageInfo.page}&pageSize=${this.pageInfo.size}`;
      let params = {
        tyshxydm: this.userInfo.enterpriseInfo.tyshxydm,
        orderBy: this.sortByType,
        name: this.searchInfo.data.keywords
      };
      this.$httpApi.post(url, params).then((res) => {
        if (res.rows && !!res.rows.length) {
          this.listData = res.rows;
          console.log('值：',this.listData);
          this.pageInfo.total = res.total;
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
$width: 1150px;
.wrap-container {
  width: $width;
  margin: 0 auto;
}
.searchbar {
  display: -webkit-flex;
  display: flex;
  align-items: center;

  ::v-deep .form-input .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .el-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
.tabbar {
  position: relative;
  margin-top: 10px;
  font-size: 18px;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #d71517;
  }
}

.tab-item {
  display: inline-block;
  padding: 0.5rem 1rem;
  color: #d71517;
  cursor: pointer;

  &.tab--active {
    color: #fff;
    background-color: #d71517;
    // border-bottom: 4px solid #d71517;
  }
}

.wrap-content {
  background-color: #ffffff;

  .content-body {
    min-height: 5rem;
    overflow: auto;
  }
}

.policy-item {
  border: 1px solid rgba($col-theme, 0.5);
  -webkit-transition: all 0.4s ease 0s;
  -moz-transition: all 0.4s ease 0s;
  -o-transition: all 0.4s ease 0s;
  transition: all 0.4s ease 0s;

  .policy-zcfs {
    .zcfs-item {
      display: inline-block;
      border: 1px solid $col-theme;
      color: $col-theme;
      margin-left: -10px;
    }
  }

  .policy-name {
    color: #000000;
    cursor: pointer;
  }

  .policy-content {
    color: #000000;
    &:hover {
      color: $col-theme;
    }
  }

  .policy-infos {
    display: -webkit-flex;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-top: 5px;

    .info-item {
      display: -webkit-flex;
      display: flex;
      align-items: flex-start;

      .info-value {
        flex: 1;
        min-width: 0;
      }
    }
  }

  .policy_footer {
    padding-top: 5px;
    padding-bottom: 5px;
    border-top: 1px solid rgba($col-theme, 0.5);
    margin-top: 5px;
    overflow: auto;
  }

  .policy-tag {
    display: -webkit-flex;
    display: flex;
    align-items: flex-start;
  }

  &:hover {
    box-shadow: 0px 1px 5px 2px rgba(0, 0, 0, 0.1);
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    transform: translateY(-2px);
  }

  .result {
    font-size: 18px;
    right: 36px;
  }
}
::v-deep {
  .el-input--medium {
    width: 300px !important;
  }
}
.content-header {
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #1472FF;
}
</style>
